import { createContext, useContext } from 'react';
import type { UserRole } from '../modules/users/types/users.types';
import type { ModulePermission } from '../core/types/permissions.types';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  permissions: ModulePermission[];
}

export interface AuthContextValue {
  user: AuthUser | null;
  isAdmin: boolean;
  permissions: ModulePermission[];
  isLoading: boolean;
  login: (credentials: { username: string; password: string }) => Promise<{
    userId: string;
    message: string;
  }>;
  verifyOtp: (payload: { userId: string; otp: string }) => Promise<void>;
  resendOtp: (payload: { userId: string }) => Promise<{ message: string }>;
  logout: () => Promise<void>;
  updateCurrentUser: (updates: Partial<AuthUser>) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
